export default __webpack_public_path__ + "src/assets/icn-collateralization.76b3165baa77b4f236e8432e748e257f.svg";